
import React from 'react';
import firebase from 'firebase';



const firestore = firebase.firestore();
const settings = {/* your settings... */ timestampsInSnapshots: true};
firestore.settings(settings);

var status = firestore.collection("systemStatus").doc("status");



export default class FzoFeed extends React.Component {
    state = {
        fzoStatus : "",
        fzoLastupdated : "",
    }


    getDoc = status.get()
        .then(doc => {
            if (!doc.exists) {
                console.log('No status document!');
            } else {
                console.log('Document data:', doc.data());
                this.setState({fzoStatus : doc.data().fzofeed})
                this.setState({fzoLastupdated :  doc.data().fzoepoch})
            }
        })
        .catch(err => {
            console.log('Error getting document', err);
        });

    render(){
        return (
            <div>
            <p>FoZ-BO Status: {this.state.fzoStatus} . Last checked : {this.state.fzoLastupdated} </p>      
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Component/FzoFeed.js